import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IHomepageModelState } from './homepage-module.reducer';
import * as fromReducer from './homepage-module.reducer';

const getHomepageModuleState = createFeatureSelector<IHomepageModelState>('homepageModule');

export const getHomepageModuleToken = createSelector(
  getHomepageModuleState,
  fromReducer.getHomepageModuleToken
);
export const getHomepageModuleActionState = createSelector(
  getHomepageModuleState,
  fromReducer.getHomepageModuleTokenActionState
);
